import { render, staticRenderFns } from "./productos.vue?vue&type=template&id=80c1a876&scoped=true"
import script from "./productos.vue?vue&type=script&lang=js"
export * from "./productos.vue?vue&type=script&lang=js"
import style1 from "./productos.vue?vue&type=style&index=1&id=80c1a876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c1a876",
  null
  
)

export default component.exports